import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { TypographyH3, TypographyP } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';
import { useCandidatesResultsContext } from '../../../Contexts/CandidateResultsContext';
import TabPaper from '../../Common/TabPaper';
import NoteRTE from './NoteRTE';
import noteValidationScheme, { CandidatesNoteForm } from './noteValidationScheme';

function NotesTab(): React.JSX.Element {
    const { results, updateNoteAsync } = useCandidatesResultsContext();
    const { applicantProfile, note } = results;

    const [saved, setSaved] = useState<boolean>(false);
    const [errorSaving, setErrorSaving] = useState<boolean>(false);

    const form = useForm({ resolver: yupResolver(noteValidationScheme), defaultValues: { noteRte: note ?? '' } });

    const saveCandidatesNote = async (values: CandidatesNoteForm) => {
        let success = true;

        try {
            setSaved(false);
            setErrorSaving(false);
            await updateNoteAsync(values.noteRte);
        } catch {
            setErrorSaving(true);
            success = false;
        } finally {
            if (success) {
                setSaved(true);
            }
        }
    };

    return (
        <TabPaper data-cy="NotesTab">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <TypographyH3 className="text-foreground text-xl">
                        {UIStrings.InterviewNotesAndHighlightsForApplicantName(applicantProfile.name)}
                    </TypographyH3>
                    <TypographyP className="text-foreground text-base">
                        {UIStrings.PleaseUseThisSectionToSummarizeTheKeyPoints}
                    </TypographyP>
                </div>
                <FormProvider {...form}>
                    <form onSubmit={form.handleSubmit(saveCandidatesNote)}>
                        <NoteRTE saved={saved} errorSaving={errorSaving} />
                    </form>
                </FormProvider>
            </div>
        </TabPaper>
    );
}

export default NotesTab;
